<template>
  <div class="features-list">
    <div class="first">
      <b-img
        src="../../../static/images/icons/edofre-icons-computer.png"
        fluid
        alt="Computer image"
      ></b-img>
      <span>Live online classes</span>
    </div>
    <div class="second">
      <b-img
        src="../../../static/images/icons/edofre-icons-bulb.png"
        fluid
        alt="Bulb image"
      ></b-img>
      <span>Adaptive practice</span>
    </div>
    <div class="third">
      <b-img
        src="../../../static/images/icons/edofre-icons-live.png"
        fluid
        alt="Live image"
      ></b-img>
      <span>Live doubts</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "feature-list-template"
};
</script>

<style scoped></style>
